// just remove this later
export const isEyewearEnabled = (draftMode: boolean) =>
  draftMode == true || true;
